import { useEffect, useState } from "react";
import { fetchJson, getCached } from "@/lib/api";

/**
 * Universal data hook used across the IMG SPA.
 *
 * When the page was prerendered, the prerender driver bakes a
 * `<script>window.__INITIAL_DATA__ = {...}</script>` block into the captured
 * HTML containing every successful GET response. On hydration this hook reads
 * the cache synchronously so the first render output matches the prerendered
 * DOM — no hydration mismatch, no visible flicker.
 */
export function useFetch(path, deps = []) {
  const initial = getCached(path);
  const [data, setData] = useState(initial !== undefined ? initial : null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(initial === undefined);

  useEffect(() => {
    let alive = true;
    fetchJson(path)
      .then((d) => {
        if (alive) setData(d);
      })
      .catch((e) => {
        if (alive) setError(e);
      })
      .finally(() => {
        if (alive) setLoading(false);
      });
    return () => {
      alive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return { data, error, loading };
}
